import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const deviceService = {
  create:        (data)     => post(ENDPOINTS.devices.list, data),
  update:        (id, data) => put(ENDPOINTS.devices.byId(id), data),
  remove:        (id)       => del(ENDPOINTS.devices.byId(id)),
  getUserMappings:         (id) => get(ENDPOINTS.devices.userMappings(id)),
  getEffectiveUserMappings:(id) => get(ENDPOINTS.devices.effectiveUserMappings(id)),
  assignUser:    (params)   => post(ENDPOINTS.devices.assignUser, null, { params }),
  unassignUser:  (params)   => del(ENDPOINTS.devices.unassignUser, { params }),
};
